import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Industries } from "@/components/site/Industries";
import { WhyUs } from "@/components/site/WhyUs";
import { Process } from "@/components/site/Process";
import { Coverage } from "@/components/site/Coverage";
import { Partners } from "@/components/site/Partners";
import { Contact } from "@/components/site/Contact";
import { MobileCallBar } from "@/components/site/MobileCallBar";
import AdminPage from "@/pages/Admin";

function Site() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="site grain relative min-h-screen [overflow-x:clip] bg-[#0A0A0A] font-body text-zinc-100">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Industries />
        <WhyUs />
        <Process />
        <Coverage />
        <Partners />
      </main>
      <Contact />
      <MobileCallBar />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Site />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <Toaster theme="dark" position="top-center" />
    </BrowserRouter>
  );
}

export default App;
